export const genres = [
  { _id: "001", name: "Action" },
  { _id: "002", name: "Comedy" },
  { _id: "003", name: "Thriller" },
];

export function getGenres() {
  return genres.filter((g) => g);
}
